import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { calculateOrderItemsSubtotal, thousandSeparator } from "utils"
import classes from "./FoodSidebarTotal.module.scss"

const FoodSidebarTotal = () => {
  const [t] = useTranslation()

  const orderForEditDetails =
    useSelector(state => state.orderForEditDetails)

  const order = useSelector(state => state.order)

  const editMode = orderForEditDetails !== null

  const showCheckout = !editMode

  if (!showCheckout) return null

  const orderItemsSubTotal =
    calculateOrderItemsSubtotal(order.items)

  const orderCombosSubTotal =
    order.combos.reduce((t, combo) =>
      t += combo.comboSetSalePrice
      , 0
    )

  const totalSystemDiscounts =
    order.items.reduce((to, item) =>
      to += (item.systemDiscount > 0 ? item.systemDiscount : 0) * item.quantity
      , 0
    )

  const subtotal =
    orderCombosSubTotal +
    orderItemsSubTotal -
    totalSystemDiscounts

  if (subtotal === 0) return null

  return (
    <div className={classes["row"]}>
      <div className={classes["total"]}>
        {t("مجموع_اقلام")}
      </div>
      <div className={classes["bold"]}>
        {thousandSeparator(subtotal)}
      </div>
    </div>
  )
}

export default React.memo(FoodSidebarTotal)